export enum ProviderTypeEnum {
  Anthropic = 'Anthropic',
  OpenAI = 'OpenAI',
  OpenAICodex = 'OpenAICodex',
  OpenAICompatible = 'OpenAICompatible'
}
